<template>
  <div>
    <MemberTitle member_title="會員資料" member_eng_title="Member Information"/>
    <div class="member_info_box">
      <div>
        <form>
          <div class="inputbox_container">
            <label for="#email">E-mail<span> 已驗證</span></label>
            <input id="email" type="text" v-model="member_new.email" readonly>
          </div>
          <div class="inputbox_container">
            <label for="#cellphone">手機號碼</label>
            <input id="cellphone" type="text" v-model="member_new.phone_number" :class="{'no_input' : member_new.phone_number == ''}">
          </div>
          <div class="inputbox_container" v-if="phone_flag">
            <label for="#verify_code">手機驗證碼</label>
            <input id="verify_code" type="text" v-model="verify" :class="{'no_input' : verify == ''}">
            <div class="sms_message">
              <a href="javascript:void(0);" @click="get_sms" :class="{'no_click' : sec !=0 }">取得驗證碼</a>&nbsp;
              <span v-if="sec!=0">下次發送{{sec}}秒</span>
            </div>
            <p>※請打開您的手機接收簡訊，我們將傳送給您6位數字的手機驗證碼</p>
          </div>
          <div class="inputbox_container">
            <label for="#name">姓名</label>
            <input id="name" type="text" v-model="member_new.name" :class="{'no_input' : member_new.name == ''}">
          </div>
          <div class="inputbox_container">
            <label for="#cid">身分證末六碼</label>
            <input id="cid" type="text" v-model="member_new.cid" :class="{'no_input' : member_new.cid == ''}">
          </div>
          <div class="inputbox_container d-sm-flex">
            <div>
              <label for="#gender">性別</label>
              <br>
              <span :class="{'no_input' : member_new.gender == -1}">
                <input name="gender" type="radio" value=1 v-model="member_new.gender">男性
                <input name="gender" type="radio" value=0 v-model="member_new.gender">女性
              </span>
            </div>
            <div>
              <label for="">生日</label>
              <DatePick style="width: 100%;" v-model="member_new.birthday" clearable format="YYYY-MM-DD" :disabled-date="disabledDate"></DatePick>
            </div>
          </div>
          <div class="inputbox_container">
            <label for="">縣市/鄉鎮[市]區</label>
            <section class="mb-2 d-flex">
              <input id="address" type="text" disabled=disabled :placeholder="zipid" :class="{'no_input' : zipid == 0}">
              <select class="selectbox" name="county_select" v-model="county_select" :class="{'no_input' : county_select == 0}">
                <option value="0" disabled selected>請選擇縣市</option>
                <option v-for="item in zip" :key="item.id" :value="item.id" >{{item.county}}</option>
              </select>
              <select class="selectbox" name="city_select" v-model="city_select" :class="{'no_input' : city_select == -1}">
                <option value="-1" disabled selected>請選擇行政區</option>
                <option v-for="item in city" :key="item.id" :value="item.id">{{item.city}}</option>
              </select>
            </section>
            <input id="addressText" type="text" placeholder="請輸入詳細地址" v-model="address_data" :class="{'no_input' : address_data == ''}">
          </div>
        </form>
        <MoreButton button_text="修改" @click.native="submit_register_edit" button_href="javascript:void(0);" :loading="loading"></MoreButton>
        <!-- <MoreButton v-if="content" button_text="回首頁" button_href="/"></!-->
      </div>
    </div>
    <BaseFooter />
  </div>
</template>
<script>
import MemberTitle from '@/components/member/MemberTitle'
import MoreButton from "@/components/base/MoreButton"
import BaseFooter from "@/components/base/BaseFooter"
import VueDatepickerLocal from 'vue-datepicker-local'
import zipcode from '@/plugins/zipcode'
export default {
  name: 'MemberInfo',
  components: {
    MemberTitle: MemberTitle,
    DatePick: VueDatepickerLocal,
    MoreButton: MoreButton,
    BaseFooter: BaseFooter,
  },
  data() {
    return {
      token: this.$cookies.get('member').token,
      loading: false,
      phone_flag: null,
      member_old: {},
      member_new: {},

      verify: '', // 假如手機號碼有更換再發送驗證碼
      sec: 0,

      convert_bir: '',

      // 地址參數設定
      address_error: '',
      zip: zipcode,
      city: '',
      county_select: 0,
      city_select: -1,
      city_check: true,
      zipid: 0,
      county_data: '', // 選擇的縣市
      city_data: '',    // 選擇的行政區
      zip_data: '',    // 選擇的郵遞區號
      road: '',        // 如果有值會直接取出
      address_data: '', // 輸入的地址
    }
  },
  created(){
    var vm = this
    // 取得會員詳細資料
    var profile_api = vm.API + "api/member/profile?token=" + vm.token
    vm.axios.get(profile_api).then(res => {
      if(res.data.status == 602 || res.data.status == 603){
        alert(res.data.message)
        vm.$cookies.remove('member')
        vm.$router.push('/')
      }
      vm.member_old = Object.assign([], res.data.data)
      // vm.member_old = res.data.data
      vm.member_new = res.data.data

      if(vm.member_new.birthday == "0000-00-00"){
        vm.member_new.birthday = ""
      } 

      // 登入後有填地址 postal_code county district road
      var county_data = res.data.data.county
      var city_data = res.data.data.district
      // 抓取 鄉鎮縣市 郵遞區號
      for(var x = 0; x < vm.zip.length; x++){
        if(county_data == vm.zip[x].county){
          vm.county_select = vm.zip[x].id
          vm.city = vm.zip[x].city
          for(var y = 0; y < vm.city.length; y++){
            if(city_data == vm.city[y].city){
              vm.city_select = vm.city[y].id
            }
          }
        }
      }
      if(vm.city_select == -1 && vm.county_select == 0){
        vm.address_check = false
      } 
      vm.address_data = res.data.data.road
      vm.city_check = false
    })
    .catch(function(error) {
      console.log(error)
    })
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/"
    },
    // 因為 DatePicker 回傳回來格式是GMT，所以要換成 YYYY-MM-DD 的格式
    dateConvert(){
      // 如果生日沒有改變就直接回傳
      if(this.member_new.birthday != ""){
        if(this.member_new.birthday != this.member_old.birthday){
          var timer = new Date((this.member_new.birthday).getTime())
          var year = timer.getFullYear()
          var month = (timer.getMonth() + 1) < 10 ? "0"+(timer.getMonth() + 1) : (timer.getMonth() + 1)
          var date = (timer.getDate()) < 10 ? "0"+(timer.getDate()) : (timer.getDate())
          return year + "-" + month + "-" + date
        } else {
          return this.member_new.birthday
        }
      } else {
        return this.member_new.birthday
      }
    }
  },
  watch: {
    // 針對生日欄位判斷是否有值，沒有則將背景改色
    // 因為套件的關係，不能使用動態class控制，才使用原生JS操控DOM
    'member_new.birthday': function(v){
      this.convert_bir = this.dateConvert
      var el = document.querySelector('.datepicker')
      var els = el.querySelectorAll('input')
      if(v == ''){
        els[0].style.background = "#f88094"
      } else {
        els[0].style.background = "#abd8ff"
      }
    },
    'member_new.phone_number':function(v){
      (v != this.member_old.phone_number) ? this.phone_flag = true : this.phone_flag = false  
    },
    county_select(id){
      var vm = this
      vm.city = vm.zip[id-1].city
      if(vm.city_check){
        vm.city_select = -1
        vm.city_data = ''
        vm.zipid = 0
        vm.zip_data = ''
        vm.road = ''
      }
      vm.county_data = this.member_new.county = vm.zip[id-1].county
      vm.city_check=true 
    },
    city_select(id){
      var vm = this
      if(vm.city_select != -1){
        vm.zipid=vm.city[id].zip
        vm.city_data = vm.member_new.district = vm.city[id].city
        vm.zip_data = vm.member_new.postal_code = vm.city[id].zip
      } else {
        vm.address_data = vm.member_new.road = ""
      }
    },
    address_data(v){
      this.member_new.road = v
    }
  },
  methods: {
    // 取得手機驗證碼
    get_sms(){
      var vm = this
      var sms_api = vm.API + "api/sms/get_verify_code"
      var verity_data = new FormData()
      verity_data.set("phone_number", vm.member_new.phone_number)
      if(vm.member_new.phone_number==""){
        alert("手機號碼不可為空")
      } else{
          vm.axios.post(sms_api, verity_data).then(res => {
          // console.log(res)
          if(res.data.status == 200){
            vm.sec = parseInt(res.data.data.expired_sec)
            alert(res.data.message)
            // 簡訊發送後開始倒數
            var interval = setInterval(() => {
              (vm.sec == 0) ? clearInterval(interval) : vm.sec--
            }, 1000);
          } else{
            alert("錯誤碼: " + " " + res.data.status + res.data.message)
          }
        })
      }
    },
    // 送出修改
    submit_register_edit(){
      var vm = this
      var profile_api = vm.API + "api/member/profile"
      var data = new FormData()
      vm.loading = true
      for(var i in vm.member_new){
        if(i == 'birthday'){
          data.set('birthday', vm.convert_bir)
        } else {
          data.set(i, vm.member_new[i])
        }
      }
      data.set("token", vm.token)
      // 首先判斷有沒有驗證碼欄位，有的話新增驗證碼欄位
      if(vm.member_new.phone_number != vm.member_old.phone_number){
        data.set("verify_code", vm.verify)
        if(vm.member_new.name != "" && vm.member_new.phone_number != "" && vm.verify != "" && vm.member_new.cid != "" && vm.member_new.gender != -1 && vm.member_new.birthday != "" && vm.county_select != 0 && vm.city_select != -1 && vm.member_new.road != "" ){
          vm.axios.post(profile_api, data).then(res => {
            // console.log(res)
            if(res.data.status == 200){
              alert('修改成功')
              vm.$router.go(0)
            } else {
              alert(res.data.message)
            }
            if(res.data.status == 602){ 
              alert(res.data.message)
              vm.$cookies.remove('member')
              vm.$router.push("/") 
            }
            vm.loading = false
          })
          .catch(function(error) {
            console.log(error)
          })
        } else {
          alert('請檢查欄位是否填寫完全')
          vm.loading = false
        }
      } else{
        if(vm.member_new.name != "" && vm.member_new.phone_number != "" && vm.member_new.cid != "" && vm.member_new.gender != -1 && vm.member_new.birthday != "" && vm.county_select != 0 && vm.city_select != -1 && vm.member_new.road != "" ){
          vm.axios.post(profile_api, data).then(res => {
            // console.log(res)
            if(res.data.status == 200){
              alert('修改成功')
              vm.$router.go(0)
            } else {
              alert(res.data.message)
            }
            if(res.data.status == 602){ 
              alert(res.data.message)
              vm.$cookies.remove('member')
              vm.$router.push("/") 
            }
            vm.loading = false
          })
          .catch(function(error) {
            console.log(error)
          })
        } else {
          alert('請檢查欄位是否填寫完全')
          vm.loading = false
        }
      }
      // console.log(this.member_new)
    },
    // 禁止選比當天還大的日期
    disabledDate(time){
      return  (new Date()) < (new Date(time))
    },
  },
}
</script>
<style>
  .member_info_box{
    width: 650px;
    height: auto;
    max-width: 100%;
    margin: auto;
    padding: 0 20px;
  }
</style>
<style>
  .datepicker>input.no_input, .no_input{ background: #f88094 !important; }
  .sms_message{
    margin: 20px 0;
  }
  .sms_message a{
    color: #8484ee;
    font-weight: 700;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #8484ee;
    transition: all .3s;
  }
  .sms_message a:hover{
    color: #ffffff;
    background: #8484ee
  }
  .no_click{
    pointer-events: none;
  }
  .inputbox_container{
    margin-top: 20px;
  }
  .inputbox_container>div{width: 50%;}
  .inputbox_container label{
    display: block;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
    margin-bottom: 7px;
  }
  .inputbox_container input{
    height: 40px;
    display: block;
    width: 100%;
    font-size: 19px;
    line-height: 2;
    border: none;
    background: #abd8ff;
    color: #000;
    padding-left: 5px;
  }
  .inputbox_container input[type="radio"]{
    height: auto;
    display: inline-block;
    width: auto;
  }
  .inputbox_container input.check_value1,
  .inputbox_container input.check_value2 {
    background: #f88094;
  }
  .inputbox_container>label>span{
    font-size: 18px;
    font-weight: bold;
    line-height: 1.8;
    color: #ff0000;
    margin-bottom: 0;
  }
  input#address{
    width: 20%;
  }
  input,select{
    padding-left: 8px;
    font-size: 17px;
    width: 100%;
    background: #abd8ff;
    border: 1px solid #c5c5c5;
    border-radius: 5px;
    transition: all .15s ease-in-out;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  }
  .selectbox{
    width: 39%;
    margin-left: 1%;
    box-sizing: border-box;
  }
  /* 日期表 css 修改 */
  .datepicker-popup, .calendar, .calendar-body { width: 100%; }
  @media(max-width: 576px){
    .inputbox_container>div {width: 100%;}
  }
</style>